<div class="empty-state">
    <div [className]="imageClass"></div>
    <itb-text [className]="headingClass" [text]="headingText"></itb-text>
    <itb-text [className]="subHeadingClass" [text]="subHeadingText"></itb-text>
    <itb-default-button *ngIf="button" [isHidden]="isHidden" [iconClassName]="iconClassName" [text]="buttonText" [className]="buttonClass" (click)="onClickEvent(buttonText)"></itb-default-button>
</div>